export default {
  namespaced: true,
  storage_provider: {
    id: 'Id',
    title: "Storage Provider",
    name: "Name",
    description: "Description",
    type: "Type",
    config: "Configuration",
    folder: "Folder",
    bucket_name: "Bucket name",
    region: "region",
    access_key_id: "Access key id",
    secret_access_key: "Secret Access Key",
    endpoint: "Endpoint",
    account_name: "Account name",
    account_key: "Account key",
    container_name: "Container name",
    sas_token: "Sas token",
    message: {
      add: "Storage Provider Added Successfully",
      edit: "Storage Provider Edited Successfully",
      delete: "Storage Provider Deleted Successfully",
      error: "An error occurred",
    } 
  }
};